import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  @media (hover: none) {
    * {
      -webkit-tap-highlight-color: transparent;
      outline: none;
    }
  }
  
  * {
    outline-color: ${({ theme }) => theme.palette.divider};
  }

  a:focus-visible,
  button:focus-visible,
  select:focus-visible,
  [tabindex]:not([tabindex="-1"]):focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.divider};
  }

  html {
    color-scheme: ${({ theme }) => theme.colorScheme};
  }
  
  body {
    line-height: unset;
    background: ${({ theme }) => theme.palette.background.paper};
  }
`;
